// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clients-flow-layout {
    display: flex;
    min-height: 100vh;
    background-color: #f5f5f5;
  }
  
  .layout-sidebars {
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 1000;
  }
  
  .layout-main-content {
    margin-left: 240px; /* Adjust based on your sidebars width */
    width: calc(100% - 240px);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .layout-content-area {
    flex: 1 1;
    padding: 20px;
    padding-top: 0;
    overflow-y: auto;
  }`, "",{"version":3,"sources":["webpack://./src/layouts/ClientsFlow/ClientsFlowLayout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,aAAa;EACf;;EAEA;IACE,kBAAkB,EAAE,wCAAwC;IAC5D,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,cAAc;IACd,gBAAgB;EAClB","sourcesContent":[".clients-flow-layout {\n    display: flex;\n    min-height: 100vh;\n    background-color: #f5f5f5;\n  }\n  \n  .layout-sidebars {\n    display: flex;\n    position: fixed;\n    left: 0;\n    top: 0;\n    height: 100vh;\n    z-index: 1000;\n  }\n  \n  .layout-main-content {\n    margin-left: 240px; /* Adjust based on your sidebars width */\n    width: calc(100% - 240px);\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .layout-content-area {\n    flex: 1;\n    padding: 20px;\n    padding-top: 0;\n    overflow-y: auto;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
